import { Validators } from '@angular/forms';
import { BaseForm } from '../../core/forms/base.form';

export class ActivityDeclarationForm extends BaseForm {

    constructor() {
        super();
        this.validationForm = this.formBuilder.group({
            projectId: [null, Validators.required],
            lotId: [null, Validators.required],
            date: [null, Validators.required],
            duration: [null, Validators.required],
            description: [null],
            profileId: [null]
        });
    }

    public toRequestForm() {
        return {
            date: this.validationForm.get('date').value,
            project_id: this.validationForm.get('projectId').value,
            lot_id: this.validationForm.get('lotId').value,
            duration: this.validationForm.get('duration').value,
            description: this.validationForm.get('description').value,
            user_profile_history_id: this.validationForm.get('profileId').value,
        };
    }
}
